import { UseEvent } from "./index";

const hideList = [
  "playSlot",
  "volt",
  "liveCasino",
  "reactiveQRVerification",
  "payment",
  "play/keno",
  "test",
];

const UseHeader = () => {
  const ev = UseEvent();
  let listener;
  const addListener = (callback) => {
    listener = ev.subscribe("header", callback);
  };
  const show = () => {
    //ev.emit("header",true)
    document.documentElement.classList.remove("hide-header");
    //document.body.classList.remove("hide-header");
  };
  const hide = (callback) => {
    //ev.emit("header",false)
    document.documentElement.classList.add("hide-header");
    //document.body.classList.add("hide-header");
  };
  const unsubscribe = () => {
    listener.unsubscribe();
  };
  const check = (path = null) => {
    let url = path ? path : new URL(window.location).pathname;
    hideList.forEach((v) => {
      if (url.indexOf(v) > -1) {
        hide();
      }
    });
  };
  return { addListener, unsubscribe, hide, show, check };
};
export default UseHeader;
